import React, { ReactNode } from 'react';
import Link from '@v2/shared/components/Link';
import { cn } from '@v2/shared/lib/utils';

/** headless: apps/topmags/layouts/MainLayout/Navigation/AccountItems/AccountItem. */
export default function AccountItem({ href, children }: { href: string; children: ReactNode }) {
  return (
    <Link
      href={href}
      className={cn(
        'text-sm italic font-serif cursor-pointer transition-colors duration-200 ease-linear',
        'text-salmon-500 hover:text-teal-500 hover:underline'
      )}
    >
      {children}
    </Link>
  );
}
